import React, { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@material-ui/core';
import { Education, EducationModule, InternshipModule } from '../../../types';
import DataTable from '../../../components/DataTable';
import StatusFlagIcon from '../StatusFlagIcon';
import SearchContext from '../../../components/search/SearchContext';
import SearchInput from '../../../components/search/SearchInput';
import EducationRepository from '../EducationRepository';
import statusLabels from '../statusLabels';
import EducationModuleRepository from './EducationModuleRepository';
import InternshipTypes from '../InternshipTypes';

interface InternshipTableDialogProps {
  education: Education;
  open: boolean;
  onClose: () => void;
}

const InternshipTableDialog = (props: InternshipTableDialogProps) => {
  const { education, open, onClose } = props;
  const [query, setQuery] = useState<string>('');

  const [modules, setModules] = useState<EducationModule[] | undefined>(
    undefined,
  );

  const repository = useMemo(
    () => new EducationModuleRepository(modules || []),
    [modules],
  );

  const searchContextValue = useMemo(
    () => ({ query, setQuery }),
    [query, setQuery],
  );

  const columns = [
    {
      name: 'Naam',
      field: 'publishedName',
      sortable: true,
    },
    {
      name: 'Type',
      field: 'internshipType',
      sortable: false,
      render: (module: InternshipModule) =>
        InternshipTypes[module.internshipType],
    },
    {
      name: 'Punten',
      field: 'points',
      sortable: false,
    },
    {
      name: 'Status',
      field: 'status',
      sortable: false,
      filter: {
        type: 'checkbox' as const,
        options: Object.entries(statusLabels).map(([, label]) => ({
          label,
          value: label,
        })),
      },
      render: (module: EducationModule) => <StatusFlagIcon module={module} />,
    },
  ];

  useEffect(() => {
    new EducationRepository()
      .getModules(education.id, ['STA'])
      .then((response) => setModules(response.data as EducationModule[]));
  }, [education.id]);

  if (!modules) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <SearchContext.Provider value={searchContextValue}>
          <Box display="flex" justifyContent="flex-end" mb={2}>
            <SearchInput />
          </Box>
          <DataTable
            id="internship-dialog-table"
            repository={repository}
            columns={columns}
            defaultFilters={{
              query: '',
              filters: {},
              order: [
                {
                  field: 'publishedName',
                  order: 'asc',
                },
              ],
            }}
          />
        </SearchContext.Provider>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Sluiten</Button>
      </DialogActions>
    </Dialog>
  );
};

export default InternshipTableDialog;
